import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { CommonActions, useNavigation } from '@react-navigation/native';
import { ResidentMobileHeaderWithMenu } from '@/components/residents/mobile/ResidentMobileHeaderWithMenu';
import { GradientBorderFrame } from '@/components/common/admin/mobile/GradientBorderFrame';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';
import { RESIDENT_PATH_TO_SCREEN } from '@/constants/residents/residentNavigation';
import { useAppDispatch } from '@/store';
import { logout as logoutAction } from '@/store/slices/authSlice';

interface MarketplaceMobileLayoutProps {
  children: React.ReactNode;
  onMenuPress?: () => void; // Made optional since menu is now built-in
  title?: string;
  showNotification?: boolean;
}

export const MarketplaceMobileLayout: React.FC<MarketplaceMobileLayoutProps> = ({
  children,
  onMenuPress,
  title = 'Community mar...',
  showNotification = true,
}) => {
  const navigation = useNavigation<any>();
  const dispatch = useAppDispatch();

  const mc = useMarketplaceColors();

  const styles = useMemo(() => StyleSheet.create({
    mobileContainer: {
      flex: 1,
      backgroundColor: mc.cardBackground,
    },
    outerFrameInner: {
      flex: 1,
    },
    innerFrameSpacing: {
      flex: 1,
      paddingTop: 2,
      paddingHorizontal: 2,
    },
    innerFrameContent: {
      flex: 1,
      backgroundColor: mc.background,
    },
}), [mc]);

  const handleLogoPress = () => {
    // Navigate to main resident screen
    navigation.navigate('Main', { screen: 'ResidentPayments' });
  };

  const handleSignOut = () => {
    dispatch(logoutAction());
  };

  const handleNavigate = (path: string) => {
    const screenName = RESIDENT_PATH_TO_SCREEN[path];
    if (!screenName) return;

    if (screenName === 'WifiConnection') {
      navigation.navigate('WifiConnection' as any);
      return;
    }

    // Reset inner stack to target screen (lateral navigation, no stacking)
    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: screenName }],
      })
    );
  };

  return (
    <View style={styles.mobileContainer}>
      <ResidentMobileHeaderWithMenu
        currentTitle={title}
        currentPath="/marketplace"
        onLogoPress={handleLogoPress}
        onSignOut={handleSignOut}
        onNavigate={handleNavigate}
        showNotification={showNotification}
      />
      <GradientBorderFrame 
        borderWidth={3} 
        borderRadius={32}
        innerStyle={styles.outerFrameInner}
      >
        <View style={styles.innerFrameSpacing}>
          <GradientBorderFrame 
            borderWidth={1} 
            borderRadius={27}
            innerStyle={styles.innerFrameContent}
          >
            {children}
          </GradientBorderFrame>
        </View>
      </GradientBorderFrame>
    </View>
  );
};

